import { render } from "./DocumentFieldFileSize.vue?vue&type=template&id=dc20141c"
import script from "./DocumentFieldFileSize.vue?vue&type=script&lang=js"
export * from "./DocumentFieldFileSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__